module.exports = __webpack_public_path__ + "static/media/vencedor.dcfb6cac.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/climasense/alternaria_papa/curativa/vencedor.png
// module id = 1991
// module chunks = 3